module.exports = __webpack_public_path__ + "img/portfolio1.a9d62cb5.png";